module.exports = __webpack_public_path__ + "media/images/common/akkodis-logo-for-white-bg-dca52bc1f0ccd64e53261c6067e9bf89.svg";